import { TextField, type TextFieldProps } from '@mui/material';

export type FloatingHelperTextFieldProps = TextFieldProps & {
  addMarginBottom?: boolean;
};

export const FloatingHelperTextField: React.FC<FloatingHelperTextFieldProps> = (
  props
) => {
  const { addMarginBottom = true, sx, ...rest } = props;

  const defaultSx = {
    '& .MuiFormHelperText-root': {
      ...(sx as any)?.['& .MuiFormHelperText-root'],
      position: 'absolute',
      bottom: -3,
      transform: 'translateY(100%)',
    },
  };

  return (
    <TextField
      {...rest}
      sx={{
        ...sx,
        ...defaultSx,
        '&&': {
          ...(addMarginBottom ? { marginBottom: 2 } : {}),
        },
      }}
    />
  );
};
